import { Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import CardImageBox from "./CardImg";

import batteries from "./batteries.png";

function ReactCard({ item }) {
  const navigate = useNavigate();

  // console.log("item ", item);

  return (
    <Card
      style={{
        // margin: "auto",
        // display: "flex",
        // justifyContent: "center",
        // alignItems: "center",
        borderRadius: "24px",
      }}
      onClick={() => navigate(`/shop/${item?._id}`)}
    >
      <div className="category-img">
        {/* <CardImageBox imgPath={batteries} /> */}
        <CardImageBox imgPath={item?.category_image} />
      </div>

      {/* <Card.Body>
        <Card.Title>Card Title</Card.Title>
        <Card.Text>
          Some quick example text to build on the card title and make up the
          bulk of the card's content.
        </Card.Text>
        <Button variant="primary">Go somewhere</Button>
      </Card.Body> */}
      <Card.Footer className="category-footer">
        {/* <h5>Batteries</h5> */}
        <h5>{item?.name}</h5>
      </Card.Footer>
    </Card>
  );
}

export default ReactCard;
